module.exports = __webpack_public_path__ + "img/bnb.162aaf57.png";